
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import { ProductionPhaseConfigurationClient } from '@/services/Services';
import * as OM from '@/Model';

@Options({})
export default class OverrideWaterFootprintForGarmentModal extends Vue {

    @Prop({
        default: ""
    }) selectedGarmentId: string;

    @Prop({
        default: () => []
    }) waterFootprintList: OM.WaterFootprint[];

    @Prop({
        default: () => []
    }) garmentIds: OM.TextIdentifier[];
    
    productionPhaseIds: OM.TextIdentifier[] = [];
    localSelectedGarmentId: string = "";
    localWaterFootprintList: OM.WaterFootprint[] = [];

    @Prop() callback: any;

    created() {
        if(this.selectedGarmentId) {
            this.localSelectedGarmentId = this.selectedGarmentId;
            var filteredList = [...this.waterFootprintList.filter(x => x.garment != null && x.garment.identifier == this.selectedGarmentId)];
            filteredList.forEach(element => {
                this.localWaterFootprintList.push({...element});
            });
        }
        else {
            var defaultWaterFootprintValues = this.waterFootprintList.filter(x => x.garment == null);
            defaultWaterFootprintValues.forEach(element => {
                this.localWaterFootprintList.push({...element});
            });
        }

        ProductionPhaseConfigurationClient.getAllConfigurations()
        .then(x => {
            var rawMatId = new OM.TextIdentifier();
            rawMatId.identifier = "00000000-0000-0000-0000-000000000000";
            rawMatId.text = "Raw Material";
            this.productionPhaseIds.push(rawMatId);

            x.forEach(element => {
                var phaseId = new OM.TextIdentifier();
                phaseId.identifier = element.identifier;
                phaseId.text = element.productionPhase;
                this.productionPhaseIds.push(phaseId);
            });
        })
    }

    get canSave(){
        return this.localWaterFootprintList.length > 0 && this.localSelectedGarmentId;
    }

    get remainingPhasesIIds() {
        return this.productionPhaseIds.filter(x => this.localWaterFootprintList.findIndex(y => y.productionPhase.identifier == x.identifier || (!y.productionPhase.identifier && x.text == "Raw Material")) == -1)
    }

    updateGarmentForEachWaterFootprintValue() {
        this.localWaterFootprintList.forEach(element => {
            var garmentTextId = this.garmentIds.filter(x => x.identifier == this.localSelectedGarmentId)[0];
            element.garment = garmentTextId;
        });
    }

    save() {
        if(!this.canSave)
            return;

        this.callback(this.localWaterFootprintList);
    }
    
}
